export const locale = {
    lang: 'es',
    data: {
        'DOCUMENT_VERIFY': {
            'INITIAL_TEXT': 'Verificación de documento',
            'EMAIL': 'Correo electrónico',
            'ID': 'Identificador privado del documento',
            'FORGOT_PASSWORD': '¿Olvidaste tu contraseña?',
            'VERIFY': 'Ver llamada',
            'LOGIN': 'Iniciar sesión',
            'BACK_TO_PANEL': 'Volver al panel',
            'ACCES_PANEL': '¿Quieres acceder al panel?',
            'NO_ACCOUNT': '¿No tienes cuenta todavía?',
            'CREATE_ACCOUNT': 'Crea una cuenta',
            'EMAIL_REQUIRED': 'Correo obligatorio',
            'INVALID_EMAIL': 'Por favor, inserta un correo válido',
            'ID_REQUIRED': 'Identificador obligatorio',
            'FILE': "Archivo",
            'CHOOSE_FILE': "Elegir archivo",
            'VERIFIED': "El documento es original",
            'NOT_VERIFIED': "El documento no corresponde o ha sido modificado",
            'BACK_TO_VERIFY': "Volver a verificar",
        }
    }
};
